// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "@media screen and (max-width:40em){.header__logo{width:8rem}}", "",{"version":3,"sources":["header.scss"],"names":[],"mappings":"AAAA,mCACE,cACE,UACF,CACF","file":"header.scss","sourcesContent":["@media screen and (max-width: 40em) {\n  .header__logo {\n    width: 8rem;\n  }\n}"]}]);
// Exports
module.exports = exports;
